import { action, computed, observable } from 'mobx';
import Config from '../../../../domain/entities/Config/Config';
import UserPreferences from '../../../../domain/entities/UserPreferences/UserPreferences';
import SavePrivacyPolicyUseCase from '../../../../use-cases/SavePrivacyPolicyUseCase';
import ConfigRepository from '../../../../repositories/ConfigRepository';
import TransactionRepository from '../../../../repositories/TransactionRepository';
import Transaction from '../../../../domain/entities/Transaction/Transaction';

interface IPaymentAcceptTermsAndPrivacyViewControllerData {
  messageOnlyTermsConditions: boolean;
  requirePrivacyPolicy: boolean;
  acceptedPrivacyPolicy: boolean;
  shouldShowNoticeOfFinanicalIncentive: boolean;
  showFinalSaleMessage: boolean;
}

interface IPaymentAcceptTermsAndPrivacyViewControllerConfig {
  configRepository: ConfigRepository;
  userPreferences: UserPreferences;
  transactionRepository: TransactionRepository;
}

class PaymentAcceptTermsAndPrivacyViewController {
  userPreferences: UserPreferences;

  configRepository: ConfigRepository;

  transactionRepository: TransactionRepository;

  @observable
  private transaction: Transaction;

  @observable private config: Config;

  constructor(config: IPaymentAcceptTermsAndPrivacyViewControllerConfig) {
    this.configRepository = config.configRepository;
    this.userPreferences = config.userPreferences;
    this.transactionRepository = config.transactionRepository;
  }

  load = async (): Promise<void> => {
    const config = await this.configRepository.getConfig();
    this.setConfig(config);
    this.transaction = await this.transactionRepository.getTransaction();
  };

  @action
  private setConfig(config: Config): void {
    this.config = config;
  }

  @computed get data(): IPaymentAcceptTermsAndPrivacyViewControllerData {
    return {
      acceptedPrivacyPolicy: this.userPreferences.acceptedPrivacyPolicy,
      messageOnlyTermsConditions: this.config && this.config.messageOnlyTermsConditions,
      requirePrivacyPolicy: this.userPreferences && this.userPreferences.requirePrivacyPolicy,
      shouldShowNoticeOfFinanicalIncentive: this.shouldShowNoticeOfFinanicalIncentive,
      showFinalSaleMessage: this.transaction?.isFinalSale,
    };
  }

  @computed private get shouldShowNoticeOfFinanicalIncentive(): boolean {
    return this.transaction?.cart?.cartItems?.filter(cartItem => cartItem.isDonationItem && cartItem.skuType === 'SE').length > 0;
  }

  setAcceptedPrivacyPolicy(value: boolean): void {
    const useCase = new SavePrivacyPolicyUseCase(value);
    useCase.execute();
  }
}

export default PaymentAcceptTermsAndPrivacyViewController;
